import React, { useState } from 'react';

import axios from 'axios';
import { TextField, Button, Box, Typography } from '@mui/material';

import './App.css';

function App() {
  const [key, setKey] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        '/login',
        new URLSearchParams({ key }),
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          withCredentials: true
        }
      );
      if (res.status === 200) {
        setError(false);
        window.location.reload();
      }
    } catch (err) {
      setError(true);
    }
  };

  return (
    <div className='App'>
      <Box sx={{ width: 300, mx: 'auto', mt: 5 }}>
        <Typography variant='h6'>Enter Access Key</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            error={error}
            label='Access Key'
            fullWidth
            value={key}
            onChange={(e) => setKey(e.target.value)}
            margin='normal'
          />
          <Button type='submit' variant='contained' fullWidth>
            Submit
          </Button>
        </form>
      </Box>
    </div>
  );
}

export default App;
